export const CABINET_IMAGE_URL =
  'https://media.doctolib.com/image/upload/q_auto:eco,f_auto,w_1024,h_700,c_limit/rbfabs0hch7wnch4othk.jpg';

export const CABINET_NAME = 'Dr Renoud';

export const TODAY_LABEL = '25 Déc. 2026';

export const ALERT_MESSAGE =
  'Fermeture exceptionnelle du 23 Décembre 2026 au 2 Janvier 2027 !';

/** Cabinet à Pau (Place Royale, centre-ville). */
export const CABINET_COORDINATES = { latitude: 43.2965, longitude: -0.3705 };
export const CABINET_CITY = 'Pau';
export const CABINET_POSTAL_CODE = '64000';
export const CABINET_ADDRESS = "12 rue de l'Orthodontie";
